module.exports = __webpack_public_path__ + "static/plan-s4-f490f79d91f6a025d880325561e4cea2.png";